
import WaitingForHelpList from './src/waitingHelp/WaitingForHelpList.vue' //待求助列表 
import WaitingForHelpInfo from './src/waitingHelp/WaitingForHelpInfo.vue' //带求助详情
import WaitingHandle from './src/waitingHelp/WaitingHandle.vue' //带求助详情

import ClosingForHelpInfo from './src/waitingHelp/ClosingForHelpInfo.vue' //待结案求助详情

import CallForHelpList from './src/callForHelp/CallForHelpList.vue' //求助电话管理
import CallForHelpInfo from './src/callForHelp/CallForHelpInfo.vue' //求助电话管理详情

import SeekHelpAlarmInfo from './src/waitingHelp/SeekHelpAlarmInfo.vue' //求助预警详情
import SeekHelpAlarmList from './src/waitingHelp/SeekHelpAlarmList.vue' //求助预警管理

let views = {
  WaitingHandle,
  WaitingForHelpList,
  WaitingForHelpInfo,
  ClosingForHelpInfo,
  CallForHelpList,
  CallForHelpInfo,
  SeekHelpAlarmList,
  SeekHelpAlarmInfo

};

export default views;